var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-end gap-6"},[_c('CustomInput',{staticClass:"w-100",attrs:{"placeholder":"Search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }